/**
 * Hex accent colours for individual HITL workflow steps.
 */
export const StepColors = {
	pink: '#e3538f',
	lengthFocus: '#f59e0b',
} as const;
